var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"wrapper"}},[_c('NavBar',{attrs:{"user":_vm.user}}),_c('SideBar',{attrs:{"user":_vm.user,"is-condensed":_vm.isMenuCondensed}}),_c('div',{staticClass:"content-page"},[_c('div',{staticClass:"content"},[_c('div',{},[_vm._t("default")],2)])])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }